/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { getMaxContentWidth } from '../../utils/common.utils';

@Component({
  selector: 'sysque-dropdown-service-type',
  templateUrl: './sysque-dropdown-service-type.component.html',
  styleUrls: ['./sysque-dropdown-service-type.component.scss'],
  standalone: false
})
export class SysqueDropdownServiceTypeComponent {
  @Input() data: string[];
  @Input() disabled: boolean;
  @Input() placeholder: string;
  @Input() width: string;
  @Input() height: string = '30px';
  @Input() serviceTypeName: string;
  @Output() openContextMenu = new EventEmitter<string>();
  @Output() valueChanged: EventEmitter<string> = new EventEmitter<string>();

  public calculatedWidth: string = 'auto'; // Dynamically calculated width

  public ngOnInit(): void {
    this.calculatedWidth = getMaxContentWidth(this.data);
  }

  public handleContextMenu(item: string): void{
    this.openContextMenu.emit(item);
  }

  public onValueChanged($event: string): void {
    this.calculatedWidth = getMaxContentWidth(this.data)
    this.valueChanged.emit($event);
  }
}
